import { Navigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import PropTypes from "prop-types";

const AdminProtectedRoute = ({ children }) => {
  const { accounts } = useMsal();

  // Check if user is authenticated
  if (accounts.length === 0) {
    return <Navigate to="/login" />;
  }

  const userRoles = accounts[0]?.idTokenClaims?.roles || [];
  const isAdmin = userRoles.includes("Admin");

  return isAdmin ? children : <Navigate to="/" />;
};

AdminProtectedRoute.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.element,
  ]).isRequired,
};

export default AdminProtectedRoute;
